import { autoinject } from 'aurelia-framework';
import { ValidationMessageProvider } from 'aurelia-validation';
import { ResourceService } from './resourceService';

@autoinject
export class ValidationConfig {
    constructor(private resourceService: ResourceService) { }

    configure() {
        this.configureValidationMessages();
    }

    private configureValidationMessages() {
        const resources = this.resourceService;
        ValidationMessageProvider.prototype.getMessage = function (key) {
			if (key === "required") { key = "ValidationError_Required"; }
            const resourceText = resources.getResource(key);
            return this.parser.parse(resourceText);
        };
    }
}
